import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BlockPaging from '@/PlugableControls/BlockPaging';
export default {
  name: 'App',
  data: function data() {
    return {
      Key: 0,
      MobileMenuKey: 0,
      LastMobileMenuItemClickTime: new Date(),
      RoomYList: [],
      SelectedIndex: 0,
      MobileMenuFixed: false,
      BlockPagingChangeIndexHander: null,
      MobileMenuItemListData: {
        RecordPerPage: 4,
        MobileRecordPerPage: 3,
        PlayMode: "Normal",
        blockitemlist: []
      },
      RoomPictureListData: {
        RecordPerPage: 5,
        MobileRecordPerPage: 4,
        ClassName: "RoomPictureList",
        PlayMode: "Normal",
        blockitemlist: []
      },
      Rooms: [],
      RoomsBak: [{
        Title: "等候室",
        //手術室名稱
        IconColor: "#a0a0f0",
        MapPicturePath: "/Static/UploadFile/Room/A03-A-03.jpg",
        BackgroundPicturePath: "/Static/UploadFile/Room/A03-A-01.jpg",
        RoomPictures: [{
          PicturePath: "/Static/UploadFile/Room/A03-A-01.jpg",
          Title: "T1"
        }, {
          PicturePath: "/Static/UploadFile/Room/A03-A-02.jpg",
          Title: "T2"
        }, {
          PicturePath: "/Static/UploadFile/Room/A03-A-03.jpg",
          Title: "FDSDFDSA"
        }, {
          PicturePath: "/Static/UploadFile/Room/A03-A-04.jpg",
          Title: "FDSDFDSA"
        }, {
          PicturePath: "/Static/UploadFile/Room/A03-A-05.jpg",
          Title: "FDSDFDSA"
        }, {
          PicturePath: "/Static/UploadFile/Room/A03-A-06.jpg",
          Title: "FDSDFDSA"
        }]
      }, {
        Title: "諮詢區",
        //手術室名稱
        IconColor: "#8911c0",
        MapPicturePath: "/Static/UploadFile/Room/A03-A-03.jpg",
        BackgroundPicturePath: "/Static/UploadFile/Room/A03-A-02.jpg",
        RoomPictures: ["/Static/UploadFile/IMG_03415830624757456857.jpg", "/Static/UploadFile/Room/A03-A-02.jpg", "/Static/UploadFile/Room/A03-A-03.jpg"]
      }, {
        Title: "複診區",
        //手術室名稱
        IconColor: "#67a100",
        MapPicturePath: "/Static/UploadFile/Room/FLOOR-PLAN1.png",
        BackgroundPicturePath: "/Static/UploadFile/Room/A03-A-03.jpg",
        RoomPictures: ["/Static/UploadFile/Room/A03-A-01.jpg"]
      }, {
        Title: "手術室",
        //手術室名稱
        IconColor: "#8711e0",
        MapPicturePath: "/Static/UploadFile/Room/FLOOR-PLAN1.png",
        BackgroundPicturePath: "/Static/UploadFile/Room/A03-A-04.jpg",
        RoomPictures: ["/Static/UploadFile/Room/A03-A-01.jpg", "/Static/UploadFile/Room/A03-A-02.jpg", "/Static/UploadFile/Room/A03-A-03.jpg", "/Static/UploadFile/Room/A03-A-04.jpg", "/Static/UploadFile/Room/A03-A-05.jpg"]
      }]
    };
  },
  methods: {
    BindPictureListEvent: function BindPictureListEvent(blockPagingChangeIndexHander) {//this.BlockPagingChangeIndexHander = blockPagingChangeIndexHander;
    },
    OnRoomMenuItemClick: function OnRoomMenuItemClick(room, index) {
      this.SelectedIndex = index;
      this.Key++;

      if (this.BlockPagingChangeIndexHander != null) {
        this.BlockPagingChangeIndexHander(0);
      }
    },
    OnRoomPictureListContainerClick: function OnRoomPictureListContainerClick(e) {//if (window["OpenPictureMask"] != null) {
      //    window["OpenPictureMask"](e.target, 0);
      //}
    },
    OnRoomPictureClick: function OnRoomPictureClick(index, item, blockPagingElement) {
      if (window["OpenPictureMask"] != null) {
        window["OpenPictureMask"](blockPagingElement, item.PicturePath);
      }
    },
    OnMobileMenuItemClick: function OnMobileMenuItemClick(index) {
      var blockItemElements;
      var anchorElement;
      var i;
      this.SelectedIndex = index;
      this.Key++;
      this.LastMobileMenuItemClickTime = new Date();
      anchorElement = document.querySelector("A[name='Room_" + index + "']");
      window.scrollTo(0, this.GetClientTop(anchorElement));
      blockItemElements = document.querySelectorAll(".MobileMenuItemList .BlockItem");

      for (i = 0; i < blockItemElements.length; i++) {
        blockItemElements[i].classList.remove("Focus");

        if (i == index) {
          blockItemElements[i].classList.add("Focus");
        } else {
          blockItemElements[i].classList.remove("Focus");
        }
      } //if (this.BlockPagingChangeIndexHander != null) {
      //    this.BlockPagingChangeIndexHander(0);
      //}

    },
    GetRoomPictureListData: function GetRoomPictureListData(room) {
      var listData = {
        RecordPerPage: 5,
        MobileRecordPerPage: 4,
        PlayMode: "Normal",
        blockitemlist: [{
          RichHtml: "<div class='PictureContainer Cover'></div>"
        }]
      };
      var i;
      listData.blockitemlist.length = 0;

      if (room.RoomPictures != null) {
        for (i = 0; i < room.RoomPictures.length; i++) {
          var picture = void 0;
          picture = room.RoomPictures[i];

          if (_typeof(picture) == "object") {
            listData.blockitemlist.push({
              SourceIndex: i,
              PicturePath: picture.PicturePath,
              Description: picture.Description,
              RichHtml: "<div class='PictureContainer Cover' style='background-image:url(".concat(picture.PicturePath, ")'><img src='").concat(picture.PicturePath, "' title='").concat(picture.Title, "' style='display:none'></div>")
            });
          } else {
            listData.blockitemlist.push({
              SourceIndex: i,
              PicturePath: picture,
              RichHtml: "<div class='PictureContainer Cover' style='background-image:url(".concat(picture, ")'><img src='").concat(picture, "' style='display:none'></div>")
            });
          }
        } //end for (i = 0; i < room.RoomPicturePaths.length; i++) {

      } //end if (room.RoomPicturePaths != null) {


      return listData;
    },
    //end GetRoomPictureListData(room){
    OnAppClick: function OnAppClick(event) {},
    OnAppEscape: function OnAppEscape(event) {},
    OnResize: function OnResize(event) {
      this.SetRoomYList();
    },
    OnScroll: function OnScroll(event) {
      var currDate = new Date();
      var blockItemElements;
      var span;
      var index = -1;
      var i;
      var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      span = currDate - this.LastMobileMenuItemClickTime;

      if (currDate - this.LastMobileMenuItemClickTime > 1000) {
        console.log("MchOmsApp:OnScroll() ,span= " + span);

        for (i = 0; i < this.RoomYList.length; i++) {
          if (i == 0) {
            if (scrollTop <= this.RoomYList[i]) {
              index = i;
              break;
            }
          }

          if (i < this.RoomYList.length - 1) {
            if (this.RoomYList[i] <= scrollTop + 100 && scrollTop + 100 <= this.RoomYList[i + 1]) {
              index = i;
              break;
            }
          }
        }

        if (index < 0 && this.RoomYList.length > 0) {
          index = this.RoomYList.length - 1;
        }

        if (index >= 0) {
          this.SelectedIndex = index;
          this.$refs.MobileMenuBlockPaging.MoveToIndex(index);
        }

        blockItemElements = document.querySelectorAll(".MobileMenuItemList .BlockItem");

        for (i = 0; i < blockItemElements.length; i++) {
          blockItemElements[i].classList.remove("Focus");

          if (i == index) {
            blockItemElements[i].classList.add("Focus");
          } else {
            blockItemElements[i].classList.remove("Focus");
          }
        }
      }

      if (this.RoomYList.length > 0) {
        if (scrollTop > this.RoomYList[0] + 50) {
          this.MobileMenuFixed = true;
        } else {
          this.MobileMenuFixed = false;
        }
      }
    },
    GetClientTop: function GetClientTop(element) {
      var clientTop = element.offsetTop;

      while (element.tagName != "BODY") {
        element = element.offsetParent;

        if (element == null) {
          break;
        }

        clientTop += element.offsetTop;

        if (element == null) {
          break;
        }

        if (window.getComputedStyle(element).getPropertyValue("position") == "absolute") {
          break;
        } else if (window.getComputedStyle(element, null).getPropertyValue("position") == "fixed") {
          clientTop += this.GetScrollTop();
          break;
        }
      }

      return clientTop;
    },
    SetRoomYList: function SetRoomYList() {
      var roomElements;
      var i;
      roomElements = document.querySelectorAll(".RoomPage .Room");

      if (this.RoomYList.length != roomElements.length) {
        this.RoomYList.length = 0;

        for (i = 0; i < roomElements.length; i++) {
          this.RoomYList.push(0);
        }
      }

      for (i = 0; i < roomElements.length; i++) {
        this.RoomYList[i] = this.GetClientTop(roomElements[i]);
      }
    },
    GetQueryString: function GetQueryString(name) {
      var regex;
      var results;
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    LoadData: function LoadData() {
      var categoryNo;
      var richHtml = "";
      var room;
      var queryHandler = null;
      var i;
      categoryNo = this.GetQueryString("GeneralContentCategoryNo");
      queryHandler = window["GetLocalResponseText"];

      if (queryHandler != null) {
        queryHandler("/Page/Project/MchOmsGetRoomData.aspx?GeneralContentCategoryNo=" + categoryNo, "GET", function (responseData) {
          this.Rooms = JSON.parse(responseData);

          for (i = 0; i < this.Rooms.length; i++) {
            room = this.Rooms[i];
            richHtml = "\n<A class=\"MobileMenuItem\" >\n    <div class=\"MobileIconContainer\" style='background-color:".concat(room.IconColor, "'>\n    </div>\n    <div class=\"MobileTileContainer\"  >\n        <div class=\"MobileTitle\">\n            ").concat(room.Title, "\n        </div>\n    </div>\n</A>\n");
            this.MobileMenuItemListData.blockitemlist.push({
              SourceIndex: i,
              RichHtml: richHtml
            });
            room.PictureListData = this.GetRoomPictureListData(room);
            this.Key++;
            this.MobileMenuKey++;
          }
        }.bind(this));
      } else {
        this.Rooms = this.RoomsBak;

        for (i = 0; i < this.Rooms.length; i++) {
          room = this.Rooms[i];
          richHtml = "\n<A class=\"MobileMenuItem\" href=\"#Room_".concat(i, "\">\n    <div class=\"MobileIconContainer\" style='background-color:").concat(room.IconColor, "'>\n    </div>\n    <div class=\"MobileTileContainer\"  >\n        <div class=\"MobileTitle\">\n            ").concat(room.Title, "\n        </div>\n    </div>\n</A>\n");
          this.MobileMenuItemListData.blockitemlist.push({
            SourceIndex: i,
            RichHtml: richHtml
          });
          room.PictureListData = this.GetRoomPictureListData(room);
          this.Key++;
          this.MobileMenuKey++;
        }
      }
    }
  },
  components: {
    BlockPaging: BlockPaging
  },
  mounted: function mounted() {
    var width;
    this.LoadData();
    setTimeout(function () {
      this.SetRoomYList();
      this.OnScroll();
    }.bind(this), 1000);
    setTimeout(function () {
      this.SetRoomYList();
    }.bind(this), 3000);
  },
  created: function created() {
    var path;
    path = localStorage.getItem("Path");
    window["TopVue"] = this;
    window.addEventListener("scroll", this.OnScroll);
  },
  computed: {
    SelectedRoom: {
      get: function get() {
        var selectedRoom = {};

        if (this.SelectedIndex < this.Rooms.length) {
          selectedRoom = this.Rooms[this.SelectedIndex];
        }

        return selectedRoom;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.IsShowLoading = false;
  },
  watch: {
    '$route': function $route(to, from) {}
  }
};